export default __webpack_public_path__ + "static/media/alphabet-yellow-d.57584da0.png";